import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=30b6ffcc&scoped=true&"
import script from "./order-list.vue?vue&type=script&lang=js&"
export * from "./order-list.vue?vue&type=script&lang=js&"
import style0 from "./order-list.vue?vue&type=style&index=0&id=30b6ffcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b6ffcc",
  null
  
)

export default component.exports